import {Invite} from '@/domain/model/invite';
import {DocumentData} from 'firebase/firestore';

export class InviteMapper {
  public static map(doc: DocumentData): Invite {
    return new Invite(doc.email, doc.role, doc.mode, doc.createDate.toMillis());
  }
}
